import { IControlStyles, IDrawerStyles, IPageStyles } from "../layouts";
import { PageActionButtonProps } from "../layouts/props";
import { ControlDatagridActionButtonProps } from "./controls/components/datagrid/controlDataGrid";
import { DrawerActionButtonProps } from "./drawer/components/template/drawerTemplateButton";

export namespace VfxLib {
    //#region Datagrid Action Buttons

    interface IActionButtonType {
        [key: string]: ControlDatagridActionButtonProps;
    }

    interface IActionButtonProps {
        datagridStyles?: IControlStyles | undefined;
        displayIconOnly?: boolean | undefined;
    }

    export const datagridActionButtons = (
        props: Partial<IActionButtonProps>
    ): IActionButtonType => {
        return {
            view: {
                image: "bi bi-eye",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                eventType: "view",
                title: "View",
            },
            view_image: {
                image: "bi bi-image",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                eventType: "view-image",
                title: "Image",
            },
            copy: {
                image: "bi bi-copy",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                eventType: "copy",
                title: "Copy",
            },
            view_delete: {
                image: "bi bi-trash",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                eventType: "view",
                title: "View",
            },
            edit: {
                image: "bi bi-pencil-fill",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                eventType: "edit",
                title: "Edit",
            },
            delete: {
                image: "bi bi-trash",
                display_type: props.displayIconOnly
                    ? "image-only"
                    : "image-before-text",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                button_class: "btn-outline-danger",
                eventType: "delete",
                title: "Delete",
            },
            deactivate: {
                text: "Deactivate",
                image: "bi bi-ban",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                button_class: "btn-outline-danger",
                eventType: "deactivate",
                title: "Deactivate",
            },
            permission: {
                image: "bi bi-lock-fill",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                eventType: "permission",
                title: "Permission",
            },
            new_sibling: {
                image: "bi bi-plus",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                eventType: "new-sibling",
            },
            add_favourite: {
                image: "bi bi-star",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                eventType: "favourite",
            },
            favorited: {
                image: "bi bi-star-fill text-warning",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                eventType: "favorited",
            },
            approve: {
                image: "bi bi-hand-thumbs-up",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                eventType: "approve",
            },
            approved: {
                image: "bi bi-hand-thumbs-up-fill",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                eventType: "approved",
            },
            reject: {
                image: "bi bi-hand-thumbs-down",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                eventType: "reject",
            },
            rejected: {
                image: "bi bi-hand-thumbs-down-fill",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                eventType: "rejected",
            },
            notes: {
                image: "bi bi-journal-plus",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                eventType: "notes",
                title: "Add Notes",
            },
            view_replies: {
                image: "bi bi-card-text",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                eventType: "view-replies",
                title: "View Replies",
            },
            send_reply: {
                image: "bi bi-reply",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                eventType: "send-reply",
                title: "Send Reply",
            },
            unlock: {
                image: "bi bi-unlock",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                eventType: "unlock",
                title: "Unlock",
            },
            reset_password: {
                image: "bi bi-bootstrap-reboot",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                eventType: "reset-password",
                title: "Reset Password",
            },
            resend_confirmation_email: {
                image: "bi bi-envelope-at",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                eventType: "resend-confirmation-email",
                title: "Resend Confirmation Email",
            },
            tag: {
                image: "bi bi-tags",
                display_type: "image-only",
                style: props.datagridStyles?.datagridActionButton,
                image_style: props.datagridStyles?.datagridActionButtonIcon,
                eventType: "tag",
                title: "Tag",
            },
        };
    };

    //#endregion

    //#region Drawer Buttons

    interface IDrawerActionButtonType {
        [key: string]: DrawerActionButtonProps;
    }

    interface IDrawerActionButtonProps {
        drawerStyles: IDrawerStyles | undefined;
        onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
        formId?: string | undefined;
    }

    export const drawerActionButtons = (
        props: Partial<IDrawerActionButtonProps>
    ): IDrawerActionButtonType => {
        return {
            copy: {
                image: "bi bi-copy",
                display_type: "image-only",
                style: props.drawerStyles?.headerButton,
                image_style: props.drawerStyles?.headerButtonIcon,
                onClick: props.onClick,
                type: "button",
            },
            close: {
                image: "bi bi-x-lg",
                display_type: "image-only",
                style: props.drawerStyles?.headerButton,
                image_style: props.drawerStyles?.headerButtonIcon,
                onClick: props.onClick,
                form: props.formId,
                type: "reset",
            },
            edit: {
                image: "bi bi-pencil-fill",
                display_type: "image-only",
                style: props.drawerStyles?.headerButton,
                image_style: props.drawerStyles?.headerButtonIcon,
                onClick: props.onClick,
            },
            saveButton: {
                text: "Save",
                image: "bi bi-floppy",
                display_type: "image-before-text",
                style: props.drawerStyles?.footerButtonPrimary,
                image_style: props.drawerStyles?.footerButtonIcon,
                button_class: "footer-button-primary",
                onClick: props.onClick,
                type: "submit",
                form: props.formId,
            },
            submit: {
                text: "Submit",
                display_type: "text-only",
                style: props.drawerStyles?.footerButtonPrimary,
                image_style: props.drawerStyles?.footerButtonIcon,
                button_class: "footer-button-primary",
                onClick: props.onClick,
                type: "submit",
                form: props.formId,
            },
            delete: {
                text: "Delete",
                image: "bi bi-trash",
                display_type: "image-before-text",
                //style: props.drawerStyles?.footerButton,
                image_style: props.drawerStyles?.footerButtonIcon,
                button_class: "btn-outline-danger",
                onClick: props.onClick,
                type: "reset",
            },
            cancel: {
                text: "Cancel",
                image: "bi bi-ban",
                display_type: "image-before-text",
                //style: props.drawerStyles?.footerButton,
                image_style: props.drawerStyles?.footerButtonIcon,
                button_class: "btn-outline-danger",
                onClick: props.onClick,
                type: "reset",
            },
            deactivate: {
                text: "Deactivate",
                image: "bi bi-ban",
                display_type: "image-before-text",
                //style: props.drawerStyles?.footerButton,
                image_style: props.drawerStyles?.footerButtonIcon,
                button_class: "btn-outline-danger",
                onClick: props.onClick,
                type: "reset",
            },
        };
    };

    //#endregion

    //#region Datagrid Search
    export interface ISearchField {
        name: string;
        label: string;
        placeholder?: string;
        type?: "text" | "number";
        onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
    }

    export interface ISearchButton {
        text: string;
        type: "button" | "submit" | "reset";
        onClick?: () => void;
        className?: string;
    }

    export const searchFormFields = (
        onKeyDown: React.KeyboardEventHandler<HTMLInputElement>
    ): ISearchField[] => [
            {
                name: "name",
                label: "Name",
                placeholder: "Enter name",
                onKeyDown,
            },
        ];

    export const searchFormButtons = (
        submitForm: () => void
    ): ISearchButton[] => [
            {
                text: "Submit",
                type: "button",
                onClick: submitForm,
                className: "btn btn-primary",
            },
        ];
    //#endregion

    //#region Page Action Buttons

    interface IPageActionButtonType {
        [key: string]: PageActionButtonProps;
    }

    interface IPageActionButtonProps {
        pageStyles?: IPageStyles | undefined;
        onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
        formId?: string | undefined;
    }

    export const pageActionButtons = (
        props: Partial<IPageActionButtonProps>
    ): IPageActionButtonType => {
        return {
            close: {
                image: "bi bi-x-lg",
                display_type: "image-only",
                style: props.pageStyles?.actionButton,
                image_style: props.pageStyles?.actionButton,
                onClick: props.onClick,
                form: props.formId,
                type: "reset",
            },
            edit: {
                image: "bi bi-pencil-fill",
                display_type: "image-only",
                style: props.pageStyles?.actionButton,
                image_style: props.pageStyles?.actionButton,
                onClick: props.onClick,
            },
            saveButton: {
                text: "Save",
                image: "bi bi-floppy",
                display_type: "image-only",
                style: props.pageStyles?.actionButton,
                image_style: props.pageStyles?.actionButton,
                button_class: "btn-primary",
                onClick: props.onClick,
                type: "submit",
                form: props.formId,
            },
            submit: {
                text: "Submit",
                display_type: "text-only",
                style: props.pageStyles?.actionButton,
                image_style: props.pageStyles?.actionButton,
                button_class: "btn-primary",
                onClick: props.onClick,
                type: "submit",
                form: props.formId,
            },
            delete: {
                text: "Delete",
                image: "bi bi-trash",
                display_type: "image-only",
                style: props.pageStyles?.actionButton,
                image_style: props.pageStyles?.actionButton,
                button_class: "btn-outline-danger",
                onClick: props.onClick,
                type: "reset",
            },
            deactivate: {
                text: "Deactivate",
                image: "bi bi-ban",
                display_type: "image-only",
                style: props.pageStyles?.actionButton,
                image_style: props.pageStyles?.actionButton,
                button_class: "btn-outline-danger border-0",
                onClick: props.onClick,
                type: "reset",
            },
        };
    };

    //#endregion
}